import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "list"
}
const _hoisted_2 = { class: "scroll-content" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "content" }
const _hoisted_5 = { class: "title" }
const _hoisted_6 = { class: "subtext" }
const _hoisted_7 = { class: "text" }

import {onMounted, onUnmounted, ref, watch} from "vue";

interface Props{
  dataList:any
}

export default /*@__PURE__*/_defineComponent({
  __name: 'MessageDetail',
  props: {
    dataList: { default: [] }
  },
  setup(__props: any) {

let timeout:any=null;
const props=__props
const list = ref([]);
const hideClass=ref('hide-detail');
const setAnimation=()=>{
  timeout=setTimeout(()=>{
    let l=list.value;
    let temp:any=JSON.parse(JSON.stringify(l[0]));

    l.splice(0,1);
    l.push(temp)
    list.value=l;
    setAnimation();
  },5000)
}
watch(()=>props.dataList,(newval)=>{
  list.value=newval;
  console.log('list',list.value)
  hideClass.value='';
  if(timeout)
    clearTimeout(timeout)
  if(newval.length>1){
    hideClass.value='hide-detail';
    setAnimation();
  }
},{immediate:true})

onUnmounted(()=>{
  clearTimeout(timeout)
})

return (_ctx: any,_cache: any) => {
  const _component_van_empty = _resolveComponent("van-empty")!

  return (list.value.length===0)
    ? (_openBlock(), _createBlock(_component_van_empty, {
        key: 0,
        description: "暂无留言"
      }))
    : (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.value, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: _normalizeClass(["message-detail", list.value.length>1&&index==0?'hide-detail':'']),
              key: item.id
            }, [
              _createElementVNode("img", {
                src: item.headimg,
                class: "img"
              }, null, 8, _hoisted_3),
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, _toDisplayString(item?.nickName), 1),
                _createElementVNode("div", _hoisted_6, _toDisplayString(item?.createtime), 1),
                _createElementVNode("div", _hoisted_7, _toDisplayString(item?.messagecontent), 1)
              ])
            ], 2))
          }), 128))
        ])
      ]))
}
}

})